
define('text!areas/home/views/footer.html',[],function () { return '<nav class="navbar navbar-fixed-bottom">\r\n  <div class="navbar-inner navbar-content-center">\r\n    <span class="pull-left"><a href="http://www.addison.de" target="_blank">© 2013 ADDISON Software & Service GmbH</a></span>\r\n  </div>\r\n</nav>';});

